<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant
            type="search"
            name="plantCd"
            v-model="searchParam.plantCd"
            @input="getList"
          />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd='RAM_RISK_HAZARD_CLASS_CD'
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ramRiskHazardClassCd"
            label="LBLCLASSIFICATION"
            v-model="searchParam.ramRiskHazardClassCd"
          ></c-select>
        </div> -->
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="유해위험물질 목록"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      :columnSetting="false"
      :isExcelDown="false"
      :isFullScreen="false"
      rowKey="_rowKey"
      @linkClick="linkClick"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <!-- <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" /> -->
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "hazardChemPop",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          type: "single",
          plantCd: "",
          regulationBillCd: null,
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        regulationBillCd: null,
      },
      grid: {
        merge: [
          { index: 0, colName: "materialName" },
          { index: 1, colName: "materialName" },
        ],
        columns: [
          {
            name: "materialName",
            field: "materialName",
            label: "화학자재",
            align: "left",
            style: "width:20%",
            type: "link",
            sortable: true,
          },
          {
            name: "propertiesStateName",
            field: "propertiesStateName",
            label: "저장성상 (액체/고상/기상)",
            align: "center",
            style: "width:15%",
            sortable: true,
          },
          {
            name: "chemNmEn",
            field: "chemNmEn",
            label: "물질명",
            align: "left",
            style: "width:45%",
            type: "link",
            sortable: true,
          },
          {
            name: "casNo",
            field: "casNo",
            label: "CAS No.",
            align: "center",
            style: "width:10%",
            sortable: true,
          },
          {
            name: "limitRepval",
            field: "limitRepval",
            label: "함량 (%)",
            align: "right",
            style: "width:10%",
            sortable: true,
          },
        ],
        height: "600px",
        data: [],
      },
      editable: true,
      listUrl: "",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  watch: {
    contentHeight() {
      let height =
        this.contentHeight - this.$refs["searchbox"].$el.offsetHeight - 50;
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + "px";
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.mam.chem.hazardChem.url;
      // code setting
      if (this.popupParam.plantCd) {
        this.$set(this.searchParam, "plantCd", this.popupParam.plantCd);
      }
      // list setting
      this.getList();
    },
    getList() {
      this.searchParam.regulationBillCd = this.popupParam.regulationBillCd;
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
        this.grid.data = this.grid.data.map((row) => ({
          ...row,
          _rowKey: `${row.mdmChemId}_${row.mdmChemMaterialId}`,
        }));
      });
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "선택된 정보가 없습니다.", // 선택된 정보가 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === "single") {
        this.$emit("closePopup", [row]);
      }
    },
    linkClick(row, col) {
      if (col.name === "materialName") {
        this.popupOptions.title = "화학자재 상세";
        this.popupOptions.param = {
          mdmChemMaterialId: row ? row.mdmChemMaterialId : "",
          plantCd: row ? row.plantCd : "",
        };
        this.popupOptions.target = () =>
          import(`${"@/pages/mdm/mam/chemDetail.vue"}`);
      } else {
        this.popupOptions.title = "화학물질 상세";
        this.popupOptions.param = { mdmChemId: row ? row.mdmChemId : "" };
        this.popupOptions.target = () =>
          import(`${"@/pages/mdm/mam/chem/chemBaseDetail.vue"}`);
      }
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = "96%";
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
